<template>
  <div
    v-if="showLanguageSelector"
    class="language-selector"
    :class="{ 'short-code': useShortCode }"
  >
    <span class="language-selector__lang">{{ formattedCurrentLanguage }}</span>
    <select
      aria-label="Select language"
      ref="languageSelectorInput"
      class="language-selector__input"
      :value="currentLang"
      @change="switchLanguage"
    >
      <option v-for="(langLabel, langCode) in languages" :value="langCode" :key="langCode">
        {{ formatLanguageLabel(langLabel, langCode) }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useTranslationsStore } from '@/stores/translationsStore.js';

export default {
  name: 'LanguageSelector',
  props: {
    useShortCode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showLanguageSelector: false,
      currentLang: '',
    };
  },
  computed: {
    ...mapState(useTranslationsStore, ['languages', 'preferredLocale']),
    formattedCurrentLanguage() {
      return this.formatLanguageLabel(this.languages[this.currentLang], this.currentLang);
    },
  },
  created() {
    this.initializeLanguageSwitcher();
  },
  methods: {
    initializeLanguageSwitcher() {
      this.showLanguageSelector = Object.keys(this.languages).length > 1;
      this.currentLang = this.preferredLocale || 'en';
    },
    switchLanguage(event) {
      const toLang = event.target.value;

      if (toLang && toLang !== this.currentLang) {
        window.location.href = `/lang/${toLang}`;
      }
    },
    formatLanguageLabel(label, code) {
      if (this.useShortCode) {
        return code;
      }

      return label === 'espanol' ? 'español' : label;
    },
  },
};
</script>
